'use strict';

const i18n = require('i18next');
require('backbone.stickit');
require('bootstrap');
const ImageSelectorView = require('balus/ui/view/modal/data-content-selector');
const imageHelper = require('common/ui/template/helper/image');
const ModalBaseView = require('common/ui/view/modal/base');
const ActionRepository = require('process/domain/repository/action/index');
const ProjectUpdateService = require('common/app/service/project/update');
const ActionUpdateService = require('process/app/service/action/update');
const ActionStateEdit = require('process/ui/view/action/state-edit');
const ActionDateEdit = require('process/ui/view/action/date-edit');
const ProjectMemberEdit = require('./member-edit');
const DescriptionEdit = require('./description-edit');
const Template = require('balus/ui/template/body/project/modal/project-setting.hbs');
const Balus = require('common/util');

module.exports = ModalBaseView.extend({
    template: Template,
    ui: {
        webhookUrl: '.slack-notification .webhook',
        timelineActive: '.slack-notification .timeline-active',
        timelineChannel: '.slack-notification .timeline-channel',
        slackLang: '.slack-notification .lang',
        imageSelector: '.image-selector'
    },
    events: {
        'input @ui.webhookUrl': 'updateNotificationSettings',
        'change @ui.timelineActive': 'updateNotificationSettings',
        'input @ui.timelineChannel': 'updateNotificationSettings',
        'change @ui.slackLang': 'updateNotificationSettings',
        'click @ui.imageSelector': 'showImageSelector'
    },
    childViewEvents: {
        'change:actionDate': 'uploadable',
        'change:actionState': 'uploadable',
        'change:member': 'uploadable',
        'change:desc': 'uploadable'
    },
    modelEvents: {
        'change:name': 'uploadable',
        'change:image': 'uploadable'
    },
    regions: {
        projectActionState: '.project-action-state-wrapper',
        projectActionDate: '.project-action-date-wrapper',
        memberList: '.member-list-wrapper',
        desc: '.project-description-wrapper',
        imageSelector: '.image-selector'
    },

    bindings: {
        'input.name': 'name'
    },

    initialize: function(params) {
        this.original = this.model;
        this.model = this.model.clone();

        _.bindAll(this, 'setting', 'deleteImage');
    },

    setImage: function() {
        if(this.$('.image')) {
            this.$('.image').attr('src', imageHelper(this.model.get('image_url'), 'small'));
        }
    },

    changeDeleteImageButton: function() {
        if (this.model.get('image_url')) {
            this.$('.delete-image').show();
        } else {
            this.$('.delete-image').hide();
        }
    },

    deleteImage: function() {
        this.model.set({image_url: null});
        this.uploadable();
    },

    resetModel: function() {
        this.unstickit();
        this.stopListening(this.model);
        this.listenTo(this.model, 'validated:invalid', this.setErrors);
        this.listenTo(this.model, 'change', this.changeDeleteImageButton);
        this.stickit();
    },

    serializeData: function() {
        const json = this.model.toJSON();
        json.languages = i18n.t('languages',
            {returnObjects: true});
        return json;
    },

    onRender: function() {
        this.stickit();
        this.setupModal();

        this.showChildView('imageSelector', new ImageSelectorView({
            project: this.model,
            hideInputSelector: true,
            accept: ['image']
        }));
        this.listenTo(this.getChildView('imageSelector'), 'select', function(content) {
            const imageURL = content.getLatestVersion().getDataSource().getThumbnailURI();

            this.model.set({image_url: imageURL});
            this.trigger('formFilled');
            this.getChildView('imageSelector').hide();
        });
        this.listenTo(this.model, 'change', this.setImage);

        this.changeDeleteImageButton();
        this.listenTo(this.model, 'change', this.changeDeleteImageButton);
        this.$('.delete-image').click(this.deleteImage);

        // 通知設定
        const ntfSettings = this.model.get('notification_settings');
        if(ntfSettings && ntfSettings.slack) {
            this.ui.slackLang.val(ntfSettings.slack.lang);
        }

        const actionID = this.model.getActionID();
        ActionRepository.find(this.model).get(actionID)
            .then(action => {
                this.showChildView('projectActionState', new ActionStateEdit({
                    model: action
                }));
                this.showChildView('projectActionDate', new ActionDateEdit({
                    model: action,
                    project: this.model
                }));
            });

        this.showChildView('memberList', new ProjectMemberEdit({
            collection: this.model.getMembers({withSuspended: true}),
            context: this.getOption('context'),
            group: this.getOption('group'),
            user: this.getOption('user')
        }));

        this.showChildView('desc', new DescriptionEdit({
            model: this.model
        }));

        return this;
    },

    showImageSelector: function() {
        this.getChildView('imageSelector').show();
    },

    uploadable: function () {
        if(this.model.get('name')) {
            this.trigger('formFilled');
        } else {
            this.trigger('formEmpty');
        }
    },

    setting: function() {
        return new Promise((resolve, reject) => {
            let isValid = this.model.isValid(true);

            const actionStateEdit = this.getChildView('projectActionState');
            if(isValid) {
                isValid = actionStateEdit.validate();
            }
            const actionDateEdit = this.getChildView('projectActionDate');
            if(isValid) {
                isValid = actionDateEdit.validate();
            }

            if(!isValid) {
                Balus.logger.warn('UserSetting ValidationError:', this.model.validationError);
                reject();
            }

            let j = this.model.toJSON();
            j.members = this.getChildView('memberList').collection.chain()
                .filter(function(m) {
                    return !m.get('deleting')
                })
                .map(function(m){
                    return {
                        user: m.get('user'),
                        role: m.get('role')
                    }
                })
                .value();
            j.description = this.getChildView('desc').getJSON();

            const actionID = this.model.getActionID();
            ActionRepository.find(this.model).get(actionID)
                .then(action => {
                    const actionJSON = action.toJSON();
                    const actionStateJSON = actionStateEdit.getJSON();
                    const actionDateJSON = actionDateEdit.getJSON();
                    actionJSON.state = actionStateJSON.state;
                    actionJSON.startAt = actionDateJSON.startAt;
                    actionJSON.endAt = actionDateJSON.endAt;

                    const projectUpdateService = new ProjectUpdateService(
                        this.original, j
                    );
                    const actionUpdateService = new ActionUpdateService(
                        this.original, action.id, actionJSON
                    );
                    Promise.all([
                        projectUpdateService.update(),
                        actionUpdateService.update()
                    ]).then(resolve, reject);
                });
        });
    },

    updateNotificationSettings: function(){
        const webhookUrl = this.ui.webhookUrl.val();
        const timelineActive = this.ui.timelineActive.is(':checked');
        const timelineChannel = this.ui.timelineChannel.val();
        const lang = this.ui.slackLang.val();

        this.model.set('notification_settings', {
            slack: {
                webhook_url: webhookUrl,
                timeline: {
                    active: timelineActive,
                    channel: timelineChannel
                },
                lang: lang
            }
        });

        this.$('.slack-notification .timeline-channel').prop('disabled', !timelineActive);
        this.trigger('formFilled');
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/project/modal/project-setting.js